import { Channel } from '../../type';
import { useChannel } from '../store/useChannelHooks';
import { useCurrentChannelGuid } from './useCurrentChannelGuid';

export const useCurrentChannel = (): Channel | null => {
  const channelGuid = useCurrentChannelGuid();
  const channel = useChannel(channelGuid ?? '');
  return channel ?? null;
};
